import { DAY, HOUR, MaterialIconName } from '@gorila-shared-ui/components';
import { PaginatedColumn } from '../types/app';
import {
  ALARMS_REPORTS_PAGE,
  CONSUMPTION_REPORTS_PAGE,
  DELIVERY_REPORTS_PAGE,
  DOOR_REPORTS_PAGE,
  EVIDENCES_REPORTS_PAGE,
  PATHS_REPORTS_PAGE,
  ROUTE_REPORTS_PAGE,
  TELEMETRY_REPORTS_PAGE,
} from './app';
import { FLEET_OPERATIONAL_REPORTS_PAGE, FLEET_SERVICE_REPORTS_PAGE } from './fleet';

export const REPORTS_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Activo / Grupo',
    key: 'asset',
    flex: 3,
  },
  {
    label: 'Desde',
    key: 'from',
    flex: 2,
  },
  {
    label: 'Hasta',
    key: 'to',
    flex: 2,
  },
  {
    label: 'Estatus',
    key: 'status',
    flex: 1,
  },
  {
    label: 'Procesado',
    key: 'processed',
    flex: 2,
    centered: false,
  },
  {
    label: 'Acciones',
    key: 'actions',
    maxWidth: 120,
    centered: true,
  },
];

export const REPORT_INTERVAL_OPTIONS = [
  {
    id: 2 * HOUR,
    label: '2 Horas',
  },
  {
    id: 12 * HOUR,
    label: '12 Horas',
  },
  {
    id: 24 * HOUR,
    label: '24 Horas',
  },
  {
    id: 7 * DAY,
    label: '7 Días',
  },
];

export const REPORT_TYPE_OPTIONS: {
  id: string;
  route?: string;
  label: string;
  description?: string;
  icon: MaterialIconName;
  comingSoon?: boolean;
  children?: {
    id: string;
    route: string;
    label: string;
  }[];
}[] = [
  {
    id: ROUTE_REPORTS_PAGE.id,
    route: ROUTE_REPORTS_PAGE.route,
    label: 'Actividad de conducción',
    description: 'Revise la actividad de conducción acumulada y detallada por vehículo.',
    icon: 'assignment_late',
  },
  {
    id: PATHS_REPORTS_PAGE.id,
    route: PATHS_REPORTS_PAGE.route,
    label: 'Historial de viajes',
    description: 'Revise los viajes realizados por los vehículos.',
    icon: 'map',
  },
  {
    id: 'adasReports',
    label: 'Reportes ADAS',
    icon: 'warning',
    children: [
      {
        id: ALARMS_REPORTS_PAGE.id,
        route: ALARMS_REPORTS_PAGE.route,
        label: 'Reporte de alarmas',
      },
      {
        id: EVIDENCES_REPORTS_PAGE.id,
        route: EVIDENCES_REPORTS_PAGE.route,
        label: 'Historial de evidencias',
      },
    ],
  },
  {
    id: TELEMETRY_REPORTS_PAGE.id,
    route: TELEMETRY_REPORTS_PAGE.route,
    label: 'Telemetría',
    description: 'Reporte de telemetría.',
    icon: 'summarize',
  },
  {
    id: CONSUMPTION_REPORTS_PAGE.id,
    route: CONSUMPTION_REPORTS_PAGE.route,
    label: 'Consumo media',
    description: 'Revise el límite y la cantidad de MB consumidos por dispositivo.',
    icon: 'videocam',
  },
  {
    id: DOOR_REPORTS_PAGE.id,
    route: DOOR_REPORTS_PAGE.route,
    label: 'Apertura / Cierre',
    description: 'Revise los eventos de apertura y cierre de puerta.',
    icon: 'car_door',
  },
  {
    id: DELIVERY_REPORTS_PAGE.id,
    route: DELIVERY_REPORTS_PAGE.route,
    label: 'Entregas',
    description: 'Reporte diario de entregas.',
    icon: 'local_shipping',
  },
];

export const FLEET_REPORT_TYPE_OPTIONS: {
  id: string;
  route: string;
  label: string;
  description: string;
  icon: MaterialIconName;
}[] = [
  {
    id: 'services',
    route: FLEET_SERVICE_REPORTS_PAGE.route,
    label: 'Servicios',
    description: 'Revise los servicios realizados de cada vehículo.',
    icon: 'safety_check',
  },
  {
    id: 'operational',
    route: FLEET_OPERATIONAL_REPORTS_PAGE.route,
    label: 'Operaciones',
    description: 'Revise las operaciones de sus vehículos.',
    icon: 'article',
  },
];

export const ROUTE_DATE_COLUMN_SIZE = 2;
export const ROUTE_STATUS_COLUMN_SIZE = 1;
export const ROUTE_EVENT_COLUMN_SIZE = 2;
export const ROUTE_SPEED_COLUMN_SIZE = 1;
export const ROUTE_ADDRESS_COLUMN_SIZE = 3;
export const ROUTE_IDENT_COLUMN_SIZE = 3;
export const ROUTE_LABEL_COLUMN_SIZE = 4;
export const ROUTE_DATE_COLUMN_MAX_WIDTH = 150;
export const ROUTE_STATUS_COLUMN_MAX_WIDTH = 60;
export const ROUTE_SPEED_COLUMN_MAX_WIDTH = 80;

export const ROUTE_EVENTS_COLUMNS = [
  {
    title: 'Fecha',
    size: ROUTE_DATE_COLUMN_SIZE,
    maxWidth: ROUTE_DATE_COLUMN_MAX_WIDTH,
    centered: false,
  },
  {
    title: 'Estatus',
    size: ROUTE_STATUS_COLUMN_SIZE,
    maxWidth: ROUTE_STATUS_COLUMN_MAX_WIDTH,
    centered: true,
  },
  {
    title: 'Evento',
    size: ROUTE_EVENT_COLUMN_SIZE,
    centered: true,
  },
  {
    title: 'Velocidad',
    size: ROUTE_SPEED_COLUMN_SIZE,
    maxWidth: ROUTE_SPEED_COLUMN_MAX_WIDTH,
    centered: true,
  },
  {
    title: 'Dirección',
    size: ROUTE_ADDRESS_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
];

export const EXTENDED_ROUTE_EVENTS_COLUMNS = [
  {
    title: 'Ident',
    size: ROUTE_IDENT_COLUMN_SIZE,
    maxWidth: undefined,
    centered: false,
  },
  {
    title: 'Etiqueta',
    size: ROUTE_LABEL_COLUMN_SIZE,
    maxWidth: undefined,
    centered: false,
  },
  ...ROUTE_EVENTS_COLUMNS,
];

export const TELEMETRY_DATE_COLUMN_SIZE = 2;
export const TELEMETRY_OPERATIONAL_STATE_COLUMN_SIZE = 2;
export const TELEMETRY_SPEED_COLUMN_SIZE = 1;
export const TELEMETRY_RPM_COLUMN_SIZE = 1;
export const TELEMETRY_IDENT_COLUMN_SIZE = 3;
export const TELEMETRY_LABEL_COLUMN_SIZE = 4;
export const TELEMETRY_ADDRESS_COLUMN_SIZE = 3;
export const TELEMETRY_DATE_COLUMN_MAX_WIDTH = 150;
export const TELEMETRY_SPEED_COLUMN_MAX_WIDTH = 80;

export const TELEMETRY_EVENTS_COLUMNS = [
  {
    title: 'Fecha',
    size: TELEMETRY_DATE_COLUMN_SIZE,
    maxWidth: TELEMETRY_DATE_COLUMN_MAX_WIDTH,
    minWidth: undefined,
  },
  {
    title: 'Estado',
    size: TELEMETRY_OPERATIONAL_STATE_COLUMN_SIZE,
    centered: true,
  },
  {
    title: 'Velocidad',
    size: TELEMETRY_SPEED_COLUMN_SIZE,
    maxWidth: TELEMETRY_SPEED_COLUMN_MAX_WIDTH,
    centered: true,
  },
  {
    title: 'RPM',
    size: TELEMETRY_RPM_COLUMN_SIZE,
    centered: true,
    maxWidth: undefined,
  },
  {
    title: 'Dirección',
    size: TELEMETRY_ADDRESS_COLUMN_SIZE,
    maxWidth: undefined,
  },
];

export const EXTENDED_TELEMETRY_EVENTS_COLUMNS = [
  {
    title: 'Ident',
    size: TELEMETRY_IDENT_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
  {
    title: 'Etiqueta',
    size: TELEMETRY_LABEL_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
  ...TELEMETRY_EVENTS_COLUMNS,
];

export const DOOR_DATE_COLUMN_SIZE = 2;
export const DOOR_EVENT_COLUMN_SIZE = 2;
export const DOOR_DELIVERY_FENCE_COLUMN_SIZE = 2;
export const DOOR_IDENT_COLUMN_SIZE = 3;
export const DOOR_LABEL_COLUMN_SIZE = 4;
export const DOOR_ADDRESS_COLUMN_SIZE = 3;
export const DOOR_DATE_COLUMN_MAX_WIDTH = 150;

export const DOOR_EVENTS_COLUMNS = [
  {
    title: 'Fecha',
    size: DOOR_DATE_COLUMN_SIZE,
    maxWidth: DOOR_DATE_COLUMN_MAX_WIDTH,
    minWidth: undefined,
  },
  {
    title: 'Evento',
    size: DOOR_EVENT_COLUMN_SIZE,
    centered: false,
  },
  {
    title: 'P. Entrega',
    size: DOOR_DELIVERY_FENCE_COLUMN_SIZE,
    maxWidth: undefined,
  },
  {
    title: 'Dirección',
    size: DOOR_ADDRESS_COLUMN_SIZE,
    maxWidth: undefined,
  },
];

export const EXTENDED_DOOR_EVENTS_COLUMNS = [
  {
    title: 'Ident',
    size: DOOR_IDENT_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
  {
    title: 'Etiqueta',
    size: DOOR_LABEL_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
  ...DOOR_EVENTS_COLUMNS,
];

export const CONSUMPTION_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Dispositivo',
    key: 'label',
    flex: 3,
  },
  {
    label: 'Tipo',
    key: 'type',
  },
  {
    label: 'MB Consumidos',
    key: 'totalMbConsumed',
    flex: 2,
  },
  {
    label: 'Límite MB',
    key: 'maxMB',
  },
];

// Historic Evidences Report
export const MEDIA_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
} as const;
export const MEDIA_TYPE_OPTIONS = [
  {
    id: MEDIA_TYPES.IMAGE,
    label: 'Imagen',
  },
  {
    id: MEDIA_TYPES.VIDEO,
    label: 'Video',
  },
];

export const EVIDENCE_ORIGIN = {
  SAFE_GPT_ORIGIN: 'safeGpt',
  PLATFORM_ORIGIN: 'platform',
  ALARM_ORIGIN: 'alarm',
} as const;
export const EVIDENCE_ORIGIN_OPTIONS = [
  {
    id: EVIDENCE_ORIGIN.SAFE_GPT_ORIGIN,
    label: 'Safe GPT',
  },
  {
    id: EVIDENCE_ORIGIN.PLATFORM_ORIGIN,
    label: 'Plataforma',
  },
  {
    id: EVIDENCE_ORIGIN.ALARM_ORIGIN,
    label: 'Alarma',
  },
];

export const DELIVERY_REPORT_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Estatus',
    key: 'status',
    flex: 1,
  },
  {
    label: 'Procesado',
    key: 'processed',
    flex: 2,
    centered: false,
  },
  {
    label: 'Acciones',
    key: 'actions',
    maxWidth: 120,
    centered: true,
  },
];

export const EXTENDED_DELIVERY_REPORT_TABLE_COLUMNS = [
  {
    label: 'Activo',
    key: 'asset',
    flex: 3,
  },
  ...DELIVERY_REPORT_TABLE_COLUMNS,
];

export const ALARMS_DATE_COLUMN_SIZE = 2;
export const ALARMS_ALARM_COLUMN_SIZE = 2;
export const ALARMS_COORDINATES_COLUMN_SIZE = 3;
export const ALARMS_SPEED_COLUMN_SIZE = 2;
export const ALARMS_IDENT_COLUMN_SIZE = 3;
export const ALARMS_LABEL_COLUMN_SIZE = 4;
export const ALARMS_DATE_COLUMN_MAX_WIDTH = 150;

export const ALARMS_COLUMNS = [
  {
    title: 'Fecha',
    size: ALARMS_DATE_COLUMN_SIZE,
    maxWidth: ALARMS_DATE_COLUMN_MAX_WIDTH,
    centered: false,
  },
  {
    title: 'Alarma',
    size: ALARMS_ALARM_COLUMN_SIZE,
    centered: false,
  },
  {
    title: 'Coordenadas',
    size: ALARMS_COORDINATES_COLUMN_SIZE,
    centered: false,
    maxWidth: undefined,
  },
  {
    title: 'Velocidad',
    size: ALARMS_SPEED_COLUMN_SIZE,
    centered: true,
    maxWidth: undefined,
  },
];

export const EXTENDED_ALARMS_COLUMNS = [
  {
    title: 'Ident',
    size: ALARMS_IDENT_COLUMN_SIZE,
    maxWidth: undefined,
    centered: false,
  },
  {
    title: 'Etiqueta',
    size: ALARMS_LABEL_COLUMN_SIZE,
    maxWidth: undefined,
    centered: false,
  },
  ...ALARMS_COLUMNS,
];

export const PATHS_REPORT_TIME_OPTIONS = [
  {
    id: 2,
    label: '2 min',
  },
  {
    id: 5,
    label: '5 min',
  },
  {
    id: 10,
    label: '10 min',
  },
];

export const PATHS_REPORT_DISTANCE_OPTIONS = [
  {
    id: 500,
    label: '500 m',
  },
  {
    id: 700,
    label: '700 m',
  },
  {
    id: 1000,
    label: '1000 m',
  },
];

export const PATHS_REPORTS_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Activo / Grupo',
    key: 'asset',
    flex: 3,
  },
  {
    label: 'Desde',
    key: 'from',
    flex: 2,
  },
  {
    label: 'Hasta',
    key: 'to',
    flex: 2,
  },
  {
    label: 'Tiempo mínimo',
    key: 'minSeconds',
    flex: 1,
    centered: true,
    minWidth: 120,
    maxWidth: 120,
  },
  {
    label: 'Distancia mínima',
    key: 'minMeters',
    flex: 1,
    centered: true,
    minWidth: 130,
    maxWidth: 130,
  },
  {
    label: 'Estatus',
    key: 'status',
    flex: 1,
  },
  {
    label: 'Procesado',
    key: 'processed',
    flex: 2,
    centered: false,
  },
  {
    label: 'Acciones',
    key: 'actions',
    maxWidth: 120,
    centered: true,
  },
];
